import React from 'react';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrBox from 'client/components/SrBox';

import UPUtilityActivationFeedbackForm from 'client/components/UPUtilityActivationFeedbackForm/UPUtilityActivationFeedbackForm';

const UPUtilityActivationFeedbackModal = (props) => {
  return (
    <SrDarkModal>
      <SrModalContent style={{ width: '375px' }}>
        <SrBox padding="15px 0 0 0">
          <UPUtilityActivationFeedbackForm {...props} />
        </SrBox>
      </SrModalContent>
    </SrDarkModal>
  );
};

export default UPUtilityActivationFeedbackModal;
